import Navbar from "./sections/Navbar";
import HeroSection from "./sections/HeroSection";
import DetailSection from "./sections/DetailSection";

function App() {
  return (
    <div className="App">
      <Navbar />
      <HeroSection />
      <DetailSection />
    </div>
  );
}

export default App;
